// extracted by mini-css-extract-plugin
export default {"clauseHeader":"style_clauseHeader__oxdPK","clauseWrapper":"style_clauseWrapper__GU0vg"};